import {AirportDetailsComponent} from './airport-detail-component';
import Text from '@/components/react-native/text';
import TouchableOpacity from '@/components/react-native/touchable-opacity';
import View from '@/components/react-native/view';
import useAirportNote from '@/stores/airport-note';
import {useNavigate} from 'react-router-dom';

const AirportScreen = () => {
  const airportNoteInfo = useAirportNote((state) => state.airportNoteInfo);
  const navigate = useNavigate();
  const onClose = () => {
    navigate('/dashboard/airline-admin/airport-information');
  };
  return (
    <View className="flex-1 w-full bg-[#030015] relative overflow-hidden">
      <View className="h-[48px] flex-row items-center justify-between px-[16px] sticky top-[0px] bg-[#030015] z-[5]">
        <div onClick={onClose} className="cursor-pointer flex-row items-center">
          <svg width={21} height={22} viewBox="0 0 21 22" fill="none">
            <path
              d="M14 18l-7-7 7-7"
              stroke="#E7E5E4"
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Text
            fontFamily="Geist"
            className="text-[#C4B5FD] text-[16px] font-[600] tracking-[-0.32px]"
          >
            Airport Notes
          </Text>
          <Text
            className="text-[18px] font-[500] text-[#E7E5E4] ml-[8px] tracking-[-0.36px]"
            fontFamily="GeistMono"
          >
            {airportNoteInfo?.iata_code} / {airportNoteInfo?.icao_code}
          </Text>
        </div>
        <TouchableOpacity onClick={onClose} className="flex-row items-center">
          <svg width={40} height={40} viewBox="0 0 40 40" fill="none">
            <path
              d="M27 13L13 27m0-14l14 14"
              stroke="#E7E5E4"
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </TouchableOpacity>
      </View>
      <AirportDetailsComponent />
    </View>
  );
};

export default AirportScreen;
